/* eslint-disable max-lines */
import { hasChineseEN, isNumber } from '@/modules/mdm/utils/regList.js';
export const formConfig = {
    name: 'customerVisitDialog',
    fields: [
        {
            label: '任务状态',
            prop: 'statusCode',
            type: 'select',
            disabled: true,
            rule: [
                { required: false, message: '任务状态不能为空', trigger: ['change', 'blur'] }
            ],
            optionsKey: 'CUSTOMER_VISIT_INFO_STATUS'
        },
        {
            label: '客户编码',
            prop: 'customerCode',
            rule: [
                { required: true, message: '客户编码不能为空', trigger: ['change', 'blur'] }
            ],
            type: 'advance',
            name: '请输入',
            value: 'customerCode',
            width: 200,
            // advanceConfig配置搜索条件，tableConfig配置弹窗中的表格列信息
            advanceConfig: [
                { prop: 'customerCode', value: '客户编码' },
                { prop: 'customerName', value: '客户名称' }
            ],
            tableConfig: [
                { prop: 'customerCode', value: '客户编码' },
                { prop: 'customerName', value: '客户名称' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: '/customer/info/page',
            method: 'post',
            cbParams: ['customerCode', 'customerName#customerName', 'industryCategoriesName#typeName', 'industryCategoriesCode#typeId', 'customerGroupName', 'isGroupCustomer'],
            // eslint-disable-next-line complexity
            beforeRequest: (params) => {
                params.customerStatus = '1';
                const inputKey = (params.customerName ? params.customerName : (params.customerCode ? params.customerCode : '')).trim();
                // 检查inputKey是否符合使用name的条件
                const hasChinese = /[\u4e00-\u9fa5]/.test(inputKey);
                const englishCount = (inputKey.match(/[a-zA-Z]/g) || []).length;
                const hasSymbol = /[^\w\s]/.test(inputKey);
                // 规则: 如果inputKey包含中文、英文长度大于1、或存在符号，则使用name
                if (hasChinese || englishCount > 1 || hasSymbol) {
                    params.customerName = inputKey;
                    params.customerCode = null;
                } else {
                    params.customerName = null;
                    params.customerCode = inputKey;
                }

                return params;
            }
        },
        {
            label: '客户名称',
            prop: 'customerName',
            type: 'input',
            disabled: true,
            rule: [
                { required: true, message: '客户名称不能为空', trigger: ['change', 'blur'] }
            ]
        },
        {
            label: '客户系',
            prop: 'customerGroupName',
            type: 'input',
            disabled: true
        },
        {
            label: '内外部',
            prop: 'isGroupCustomer',
            optionsKey: 'INSIDE_OUTER_CLIENT',
            disabled: true,
            rule: [
                { required: true, message: '内外部不能为空', trigger: ['change', 'blur'] }
            ],
            type: 'select'
        },
        {
            label: '被拜访人',
            prop: 'contact',
            type: 'input',
            rule: [
                { required: false, message: '被拜访人不能为空', trigger: ['change', 'blur'] },
                {
                    pattern: hasChineseEN,
                    message: '只允许中文或者英文',
                    trigger: 'blur'
                }
            ]
        },
        {
            label: '联系方式',
            prop: 'contactMobile',
            type: 'input',
            rule: [
                { required: false, message: '联系方式不能为空', trigger: ['change', 'blur'] },
                {
                    pattern: isNumber,
                    message: '联系方式仅支持数字，当前填写包含非数字字符，请修正；',
                    trigger: 'blur'
                }
            ]
        },
        {
            label: '核心问题',
            prop: 'issues',
            type: 'custom',
            rows: 3,
            maxlength: 100,
            showWordLimit: true,
            rule: [
                { required: true, message: '核心问题不能为空', trigger: ['change', 'blur'] }
            ],
            span: 16
        },
        {
            label: '行业',
            prop: 'typeName',
            type: 'input',
            disabled: true,
            rule: [
                { required: true, message: '行业不能为空', trigger: ['change', 'blur'] }
            ]
        },
        {
            label: '片区',
            prop: 'areaName',
            type: 'input',
            disabled: true,
            rule: [
                { required: true, message: '片区不能为空', trigger: ['change', 'blur'] }
            ]
        },
        {
            label: '分公司',
            prop: 'companyName',
            type: 'input',
            disabled: true
        },
        {
            label: '经营中心',
            prop: 'businessCenterName',
            type: 'input',
            disabled: true
        },
        {
            label: '服务平台',
            prop: 'siteName',
            type: 'input',
            disabled: true
        },
        {
            label: '分级分类',
            prop: 'visitLevel',
            rule: [
                { required: true, message: 'A级分类不能为空', trigger: ['change', 'blur'] }
            ],
            type: 'select',
            disabled: true,
            optionsKey: 'CUSTOMER_VISIT_LEVEL'
        },
        {
            label: '拜访开始时间',
            prop: 'visitTimeStart',
            type: 'input',
            // timeType: 'date',
            rule: [
                { required: true, message: '拜访开始时间不能为空', trigger: 'change' }
            ],
            disabled: true
            // format: 'yyyy-MM-dd',
            // valueFormat: 'yyyy-MM-dd'
        },
        {
            label: '拜访结束时间',
            prop: 'visitTimeEnd',
            type: 'input',
            // timeType: 'date',
            rule: [
                { required: true, message: '拜访结束时间不能为空', trigger: 'change' }
            ],
            disabled: true
            // format: 'yyyy-MM-dd',
            // valueFormat: 'yyyy-MM-dd'
        },
        {
            label: '一级问题分类',
            prop: 'firstClassProblemCode',
            rule: [
                { required: true, message: '一级问题分类不能为空', trigger: ['change', 'blur'] }
            ],
            type: 'select',
            disabled: true,
            optionsKey: 'CUSTOMER_FIRST_CLASS_PROBLEM'
        },
        {
            label: '二级问题分类',
            prop: 'secondClassProblemCode',
            rule: [
                { required: true, message: '二级问题分类不能为空', trigger: ['change', 'blur'] }
            ],
            type: 'select',
            disabled: true,
            optionsKey: 'CUSTOMER_SECOND_CLASS_PROBLEM'
        },
        {
            label: '拜访责任人',
            prop: 'ownerName',
            type: 'input',
            disabled: true,
            rule: [
                { required: true, message: '拜访责任人不能为空', trigger: ['change', 'blur'] }
            ]
        },
        {
            label: '拜访责任人MIP',
            prop: 'ownerCode',
            type: 'input',
            disabled: true,
            rule: [
                { required: true, message: '拜访责任人MIP不能为空', trigger: ['change', 'blur'] }
            ]
        },
        {
            label: '审批人',
            prop: 'approverName',
            type: 'input',
            rule: [
                { required: true, message: '审批人不能为空', trigger: ['change', 'blur'] }
            ],
            disabled: true
        },
        {
            label: '审批人MIP',
            prop: 'approverCode',
            type: 'input',
            rule: [
                { required: true, message: '审批人MIP不能为空', trigger: ['change', 'blur'] }
            ],
            disabled: true
        },
        {
            label: '拜访方式',
            prop: 'visitMode',
            rule: [
                { required: false, message: '拜访方式不能为空', trigger: ['change', 'blur'] }
            ],
            type: 'select',
            optionsKey: 'CUSTOMER_VISIT_MODE',
            disabled: true
        },
        {
            label: '拜访内容记录',
            prop: 'content',
            value: 'content',
            type: 'custom',
            sourceType: 'input',
            inputType: 'textarea',
            rows: 3,
            span: 16,
            disabled: true,
            rule: [
                { required: false, message: '拜访内容记录不能为空', trigger: 'change' }
            ]
        },
        {
            label: '流程流转记录',
            prop: 'fdId',
            value: 'fdId',
            type: 'custom',
            disabled: true,
            rows: 3,
            span: 18,
            rule: [
                { required: false, message: '流程流转记录不能为空', trigger: 'change' }
            ]
        }
    ],
    height: 325
};

export const transferLogConfig = {
    selection: true,
    index: false,
    columns: [
        { label: '转办人', prop: 'handlerCode' },
        { label: '任务状态', prop: 'statusCode', type: 'select', optionsKey: 'CUSTOMER_VISIT_INFO_STATUS' },
        { label: '操作内容', prop: 'operationName' },
        { label: '转办时间', prop: 'createTime' }
    ]
};
